import { Pressable, StyleSheet } from "react-native";
import type { ViewStyle } from "react-native";
import { Text } from "react-native-paper";

interface CalculatorButtonProps {
	title: string;
	onPress: () => void;
	variant?: "orange" | "default";
	style?: ViewStyle;
}

const CalculatorButton = ({
	title,
	onPress,
	variant = "default",
	style,
}: CalculatorButtonProps) => {
	return (
		<Pressable
			style={[
				styles.button,
				variant === "orange" && styles.orangeButton,
				style,
			]}
			onPress={onPress}
		>
			<Text variant="labelMedium">{title}</Text>
		</Pressable>
	);
};

const styles = StyleSheet.create({
	button: {
		flex: 1,
		backgroundColor: "#404040",
		paddingVertical: 8,
		paddingHorizontal: 2,
		alignItems: "center",
		justifyContent: "center",
		minHeight: 36,
		borderWidth: 1,
		borderColor: "#555555",
		borderRadius: 4,
		margin: 1,
	},

	orangeButton: {
		backgroundColor: "#ff6600",
		borderColor: "#ff7700",
	},
});

export default CalculatorButton;
